// `formatValue` es opt-in (default: comportamiento previo `{value}{unit}`) —
// permite a un consumidor concreto etiquetar un valor especial (p. ej. el
// time-stop de rango_quantum: 0 = "Desactivado", no "0d") sin tocar el
// resto de sliders del registro, que siguen sin pasar la prop.
export default function SliderField({ label, value, min, max, step = 1, unit = '', onChange, formatValue }) {
  return (
    <div className="space-y-1.5">
      <div className="flex items-center justify-between">
        <span className="text-xs text-slate-600 dark:text-gray-300">{label}</span>
        <span className="text-[10px] font-medium text-slate-500 dark:text-gray-400 tabular-nums">
          {typeof formatValue === 'function' ? formatValue(value) : `${value}${unit}`}
        </span>
      </div>
      <input
        type="range"
        min={min}
        max={max}
        step={step}
        value={value}
        onChange={(e) => onChange(parseFloat(e.target.value))}
        className="w-full h-1.5 bg-slate-200 dark:bg-gray-700 rounded-lg appearance-none cursor-pointer accent-blue-600"
      />
    </div>
  )
}
